import * as tslib_1 from "tslib";
/**
 * Enumeration of all possible filter keys for airports and destinations. The enum values are used to encode the
 * search criteria in the URL, so they should be unique, concise, and descriptive.
 */
export var FilterKeys;
(function (FilterKeys) {
    FilterKeys["FuelFilter"] = "fuel";
    FilterKeys["PublicUse"] = "public";
    FilterKeys["Towered"] = "towered";
    FilterKeys["NoLandingFee"] = "nolandingfee";
    FilterKeys["CourtesyCar"] = "courtesycar";
    FilterKeys["RentalCar"] = "rentalcar";
    FilterKeys["Customs"] = "customs";
    FilterKeys["Oxygen"] = "oxygen";
    FilterKeys["Restaurant"] = "restaurant";
    FilterKeys["Camping"] = "camping";
    FilterKeys["PavedRunway"] = "paved";
    FilterKeys["Helipad"] = "helipad";
    FilterKeys["Waterway"] = "waterway";
    FilterKeys["Grass"] = "grass";
    FilterKeys["RunwayLength"] = "rwylen";
    FilterKeys["Approach"] = "approach";
    FilterKeys["Services"] = "services";
})(FilterKeys || (FilterKeys = {}));
/**
 * Search filter class. This class contains the logic for validating and applying the filter against a search result.
 */
var Filter = /** @class */ (function () {
    function Filter(filterConfig) {
        this._key = filterConfig.key;
        this._multi = filterConfig.multi;
        this._applyFn = filterConfig.apply;
        this._encodeFn = filterConfig.encode;
        this._decodeFn = filterConfig.decode;
        this._validateFn = filterConfig.validate;
        this.enabled = filterConfig.enabled;
    }
    Object.defineProperty(Filter.prototype, "key", {
        /**
         * Unique key for this filter that allows for lookup. The key is also used for encoding the filter in the URL.
         */
        get: function () {
            return this._key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Filter.prototype, "multi", {
        /**
         * Indicates if multiple instances of this filter are allowed in a single query. For instance, the fuel filter may
         * appear multiple times (fuel=100LL&fuel=Jet-A), resulting in returning airports that have all of the specified
         * fuel types available.
         */
        get: function () {
            return this._multi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Filter.prototype, "valid", {
        /**
         * Returns true if the filter is valid.
         */
        get: function () {
            return this.validate().valid;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Execute the filter to determine if a given search result passes the filter.
     * @param airport {AirportSearchResult} Search result to test
     * @returns {boolean} True if the search result satisfies the filter; false otherwise.
     */
    Filter.prototype.apply = function (airport) {
        return !this.enabled || this._applyFn(airport);
    };
    /**
     * Encode the value of this filter in the URL as a query parameter.
     * @returns {string}
     */
    Filter.prototype.encode = function () {
        return this._encodeFn();
    };
    /**
     * Decodes the filter value from the URL
     * @param v {ENCODED_VALUE} Encoded value of the filter as it appears in the URL.
     * @returns {boolean} True if the filter should be enabled; false otherwise.
     */
    Filter.prototype.decode = function (v) {
        return this._decodeFn(v);
    };
    /**
     * Validates the filter. If a filter is invalid, it will not be executed even if it is enabled.
     * @returns {QueryValidationResult}
     */
    Filter.prototype.validate = function () {
        return this._validateFn();
    };
    return Filter;
}());
export { Filter };
/**
 * Boolean filter class. Boolean filters use the enabled property as the value.
 */
var BooleanFilter = /** @class */ (function (_super) {
    tslib_1.__extends(BooleanFilter, _super);
    function BooleanFilter(filterConfig) {
        var _this = _super.call(this, Object.assign({
            encode: function () { return _this._encode(); },
            decode: function (v) { return _this._decode(v); },
            validate: function () { return _this._validate(); }
        }, filterConfig)) || this;
        return _this;
    }
    BooleanFilter.prototype._encode = function () {
        return this.enabled ? '1' : null;
    };
    BooleanFilter.prototype._decode = function (v) {
        return v === '1';
    };
    BooleanFilter.prototype._validate = function () {
        return { valid: true };
    };
    return BooleanFilter;
}(Filter));
export { BooleanFilter };
/**
 * Base class for filter components.
 */
var FilterComponentBase = /** @class */ (function () {
    function FilterComponentBase() {
    }
    return FilterComponentBase;
}());
export { FilterComponentBase };
